import { AuthEndpoint as AuthEndpointInterface } from "@/projectRoot/api-client/interfaces/endpoints/Auth.endpoint";
import ApiResponseDto from "@apiClient/interfaces/response/ApiResponse.dto";
import { KyInstance } from "ky/distribution/types/ky";
import { KyResponse } from "ky";
import DeviceTokenGenerateRequestDto from "@/projectRoot/api-client/interfaces/request/auth/DeviceTokenGenerateRequest.dto";
import DeviceTokenGenerateResponseDto from "@/projectRoot/api-client/interfaces/response/auth/DeviceTokenGenerateResponse.dto";
import LoginRequestDto from "@/projectRoot/api-client/interfaces/request/auth/LoginRequest.dto";
import RegistrationRequestDto from "@/projectRoot/api-client/interfaces/request/auth/RegistrationRequest.dto";
import InitResetPasswordRequestDto from "@/projectRoot/api-client/interfaces/request/auth/InitResetPasswordRequest.dto";
import ResetPasswordRequestDto from "@/projectRoot/api-client/interfaces/request/auth/ResetPasswordRequest.dto";
import VerifyResetTokenRequestDto from "@/projectRoot/api-client/interfaces/request/auth/VerifyResetTokenRequest.dto";

export class AuthEndpoint implements AuthEndpointInterface {

    private _httpClient: KyInstance;
    private cache: RequestCache;

    public constructor(client: KyInstance, cache: RequestCache = "no-store") {
        this._httpClient = client;
        this.cache = cache;
    }

    get httpClient(): KyInstance {
        if (!this._httpClient) {
            throw new Error('Ky http client is not initialized');
        }
        return this._httpClient;
    }

    set httpClient(kyInstance: KyInstance) {
        this._httpClient = kyInstance;
    }

    /**
     * /api/auth/device-token/generate
     */
    async deviceTokenGenerate(params: DeviceTokenGenerateRequestDto): Promise<ApiResponseDto<DeviceTokenGenerateResponseDto, undefined>> {
        return this._httpClient
            .post(`auth/device-token/generate`, { json: params, cache: this.cache })
            .then(async (kyResponse: KyResponse) => {
                if (kyResponse.status < 200 || kyResponse.status > 299) {
                    throw new Error(kyResponse.statusText)
                }
                const response: ApiResponseDto<DeviceTokenGenerateResponseDto, undefined> = await kyResponse.json();
                return response;
            });
    }

    /**
     * /api/auth/socialite/{driver}
     */
    async socialLogin(driver: string): Promise<ApiResponseDto<DeviceTokenGenerateResponseDto, undefined>> {
        return this._httpClient
            .get(`auth/${driver}`, {cache: this.cache })
            .then(async (kyResponse: KyResponse) => {
                if (kyResponse.status < 200 || kyResponse.status > 299) {
                    throw new Error(kyResponse.statusText)
                }
                const response: ApiResponseDto<DeviceTokenGenerateResponseDto, undefined> = await kyResponse.json();
                return response;
            });
    }

    /**
     * /api/auth/login
     */
    async login(request: LoginRequestDto): Promise<ApiResponseDto<DeviceTokenGenerateResponseDto, undefined>> {
        return this._httpClient
            .post(`auth/login`, { json: request, cache: this.cache })
            .then(async (kyResponse: KyResponse) => {
                if (kyResponse.status < 200 || kyResponse.status > 299) {
                    throw new Error(kyResponse.statusText)
                }
                const response: ApiResponseDto<DeviceTokenGenerateResponseDto, undefined> = await kyResponse.json();
                return response;
            });
    }

    /**
     * /api/auth/register
     */
    async register(request: RegistrationRequestDto): Promise<ApiResponseDto<DeviceTokenGenerateResponseDto, undefined>> {
        return this._httpClient
            .post(`auth/register`, { json: request, cache: this.cache })
            .then(async (kyResponse: KyResponse) => {
                if (kyResponse.status < 200 || kyResponse.status > 299) {
                    throw new Error(kyResponse.statusText)
                }
                const response: ApiResponseDto<DeviceTokenGenerateResponseDto, undefined> = await kyResponse.json();
                return response;
            });
    }

    /**
     * /api/auth/init-reset-password
     */
    async initResetPassword(request: InitResetPasswordRequestDto): Promise<ApiResponseDto<[], undefined>> {
        return this._httpClient
            .post(`auth/init-reset-password`, { json: request, cache: this.cache })
            .then(async (kyResponse: KyResponse) => {
                if (kyResponse.status < 200 || kyResponse.status > 299) {
                    throw new Error(kyResponse.statusText)
                }
                const response: ApiResponseDto<[], undefined> = await kyResponse.json();
                return response;
            });
    }

     /**
     * /api/auth/verify-reset-token
     */
    async verifyResetToken(request: VerifyResetTokenRequestDto): Promise<ApiResponseDto<[], undefined>> {
        return this._httpClient
            .post(`auth/verify-reset-token`, { json: request, cache: this.cache })
            .then(async (kyResponse: KyResponse) => {
                if (kyResponse.status < 200 || kyResponse.status > 299) {
                    throw new Error(kyResponse.statusText)
                }
                const response: ApiResponseDto<[], undefined> = await kyResponse.json();
                return response;
            });
    }

    /**
     * /api/auth/reset-password
     */
    async resetPassword(request: ResetPasswordRequestDto): Promise<ApiResponseDto<[], undefined>> {
        return this._httpClient
            .post(`auth/reset-password`, { json: request, cache: this.cache })
            .then(async (kyResponse: KyResponse) => {
                if (kyResponse.status < 200 || kyResponse.status > 299) {
                    throw new Error(kyResponse.statusText)
                }
                const response: ApiResponseDto<[], undefined> = await kyResponse.json();
                return response;
            });
    }
}

export default AuthEndpoint;